export default __webpack_public_path__ + "static/media/register.760a8263.png";